<template>
  <div id="app" v-if="!loadingRouter">
    <competition-nav v-if="isCompetitionView" />
    <Nav
      v-else
      @openModal="openModal($event)"
      :userIsLoged="userIsLoged"
      @changeLoged="changeUserIsLoged"
      :windowWidth="windowWidth"
    />
    <router-view class="router-view" />
    <Footer />
    <modalWrapper
      v-if="modal"
      :modalData="modalData"
      :component="modalComponent"
      :outsideClose="outsideClose"
      @closeModal="closeModal()"
      @changeModal="changeModal($event)"
    />
    <loader-wrapper />
    <chat-bot-wrapper />
  </div>
</template>

<script>
// @ is an alias to /src
import competitionNav from "@/components/header/competitionNav.vue";
import Nav from "@/components/header/Nav.vue";
import Footer from "@/components/Footer.vue";
import modalWrapper from "@/components/modalWrapper.vue";
import eventBus from "@/shared/eventBus.js";
import { api } from "@/api";
import { mapState } from "vuex";
import loaderWrapper from "@/components/loaderWrapper.vue";
import chatBotWrapper from "./components/chatBot/chat-bot-wrapper.vue";
export default {
  name: "app",
  components: {
    competitionNav,
    Nav,
    Footer,
    // loginModal,
    // registerModal
    modalWrapper,
    loaderWrapper,
    chatBotWrapper
  },
  data() {
    return {
      modal: false,
      modalComponent: null,
      modalData: null,
      userIsLoged: false,
      windowWidth: window.innerWidth,
      interval: null,
      outsideClose: null,
      loadingRouter: true
    };
  },
  async mounted() {
    this.$router.onReady(() => {
      this.loadingRouter = false;
      this.checkLocale();
      this.checkUserSid();
      this.interval = setInterval(this.checkUserSid, 60000);
      window.addEventListener("resize", this.onResize);
      eventBus.$on("openModal", data => {
        this.openModal(data);
      });
      eventBus.$on("closeModal", () => {
        this.closeModal();
      });
      eventBus.$on("openWSConnection", () => {
        this.setUpWSConection();
      });
      eventBus.$on("changeLoged", data => {
        this.userIsLoged = data;
      });
      this.setNotifications();
      this.setUpWSConection();
    });
  },
  methods: {
    checkLocale() {
      // console.log(this.$route);
      let curLocale = this.$route.params.lang;
      let availableLocales = Object.keys(this.$i18n.messages);
      let params = this.$route.params;
      if (!availableLocales.includes(curLocale)) {
        params.lang = "sr";
        if (this.$route.name) {
        } else {
          this.$router.push({ name: "Home", params: { lang: "sr" } });
        }
        this.$router.replace({
          name: this.$route.name,
          params: params
        });
      }
    },
    setUpWSConection() {
      this.$store.commit("openWSConnection");
      this.connection.onopen = this.onOpen;
      this.connection.onclose = this.onClose;
      this.connection.onerror = this.onError;
      this.connection.onmessage = e => {
        // console.log(this.chatVisible, JSON.parse(e.data));
        let msg = JSON.parse(e.data);
        if (msg.status === "new-connection") {
          this.logout();
          return;
        }
        if (msg.type === "ntf") {
          this.setNotifications();
          eventBus.$emit("refreshNotifications");
        } else {
          if (this.chatVisible) {
            eventBus.$emit("handleMessage", e);
          } else {
            this.setNotifications();
          }
        }
      };
    },
    onOpen(evt) {
      // console.log(evt);
    },
    onClose(evt) {
      // console.log(evt);
      // this.setUpWSConection()
    },
    onError(evt) {
      // console.log(evt);
      // this.setUpWSConection()
    },
    setNotifications() {
      if (localStorage.getItem("sid") && this.userIsLoged) {
        api
          .getNotificationsCount()
          .then(res => {
            this.$store.commit("setNotificationCounters", res.data);
          })
          .catch(e => {
            console.log(e);
          });
      }
    },
    logout() {
      api
        .logout()
        .then(res => {
          localStorage.removeItem("sid");
          this.$emit("changeLoged", false);
          this.$store.commit("setUserName", null);
          this.$store.commit("setUserAdmin", false);
          this.$store.commit("setUserImage", null);
          this.$store.commit("setDisplayName", null);
          this.$store.commit("closeWSConnection");
          if (this.$route.name !== "Home") {
            this.$router.push({
              name: "Home",
              params: { lang: this.$i18n.locale }
            });
          }
          window.location.reload();
        })
        .catch(e => {
          console.log(e);
        });
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    checkUserSid() {
      // console.log("checking sid");
      if (localStorage.getItem("sid")) {
        api
          .checkSession()
          .then(res => {
            this.userIsLoged = true;
            this.$store.commit("changeUserIsLoged", true);
            this.$store.commit("setUserName", res.data.usr_name);
            this.$store.commit("setUserImage", res.data.usr_image);
            this.$store.commit("setDisplayName", res.data.display_name);
            if (res.data.admin && res.data.admin === true) {
              this.$store.commit("setUserAdmin", true);
            }
            this.setNotifications();
          })
          .catch(e => {
            // console.log(e.response.request.status);
            if (e.response.request.status === 401) {
              this.userIsLoged = false;
              this.$store.commit("changeUserIsLoged", false);
              this.$store.commit("setUserName", null);
              this.$store.commit("setUserAdmin", false);
              this.$store.commit("setUserImage", null);
              this.$store.commit("setDisplayName", null);
              this.navigateToSafePage();
            }
          });
      } else {
        this.userIsLoged = false;
        this.$store.commit("changeUserIsLoged", false);
        this.$store.commit("setUserName", null);
        this.$store.commit("setUserAdmin", false);
        this.$store.commit("setUserImage", null);
        this.$store.commit("setDisplayName", null);
        this.setNotifications();
      }
    },
    navigateToSafePage() {
      if (this.$route.meta && this.$route.meta.sidRequired) {
        this.$router.push({
          name: "Home",
          params: { lang: this.$i18n.locale }
        });
      }
      this.setNotifications();
    },
    changeUserIsLoged(data) {
      this.userIsLoged = data;
      this.$store.commit("changeUserIsLoged", data);
      this.setNotifications();
    },
    openModal(evt) {
      this.modal = true;
      this.modalComponent = evt.component;
      this.modalData = evt.modalData;
      this.outsideClose = evt.hasOwnProperty("outsideClose")
        ? evt.outsideClose
        : true;
    },
    closeModal() {
      this.modal = false;
      this.modalComponent = null;
      this.modalData = null;
    },
    changeModal(evt) {
      this.modalComponent = evt.component;
    }
  },
  computed: {
    ...mapState(["connection", "chatVisible"]),
    isCompetitionView() {
      if (
        this.$route.name === "Competitions" ||
        this.$route.name === "Competition" ||
        this.$route.name === "CompetitionRules" ||
        this.$route.name === "CompetitionEntry" ||
        this.$route.name === "CompetitionEntryEdit" ||
        this.$route.name === "CompetitionRankList" ||
        this.$route.name === "CompetitionNoSchool"
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    isCompetitionView: {
      handler(newV) {
        if (newV) {
          localStorage.setItem("locale18", this.$i18n.locale);
          this.$i18n.locale = "en";
        } else if (newV === false) {
          if (localStorage.getItem("locale18")) {
            this.$i18n.locale = localStorage.getItem("locale18");
          }
        }
      }
    },
    "$i18n.locale": {
      handler(newLocale, oldLocale) {
        if (newLocale !== oldLocale) {
          if (this.$route.params.hasOwnProperty("lang")) {
            this.$router.replace({
              params: { lang: this.$i18n.locale },
              query: this.$route.query
            });
          } else {
            this.$router.push({
              name: "Root",
              params: { lang: this.$i18n.locale },
              query: this.$route.query
            });
          }
        }
      }
    }
  },
  destroyed() {
    eventBus.$off("openModal");
    eventBus.$off("closeModal");
    eventBus.$off("openWSConnection");
    window.removeEventListener("resize", this.onResize);
  }
};
</script>

<style lang="scss">
//v-select custom
#app {
  .vs__search {
    min-width: 120px;
    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
    letter-spacing: 0.02em;
    color: $blue-300;
    z-index: 0;
  }
  .vs__dropdown-toggle {
    background-color: $gray-100;
    border-radius: 0px;
    min-height: 50px !important;
    border: 1px solid #e8e8e8;
    border-radius: 8px;

    line-height: 42px;
  }
  .vs__open-indicator {
    margin-right: 4px;
  }
}
</style>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Figtree:ital,wght@0,300..900;1,300..900&family=Outfit:wght@100..900&display=swap");
@import "vue-select/src/scss/vue-select.scss";
// @import url('https://fonts.googleapis.com/css2?family=Catamaran:wght@300;400;500;600;700;800;900&display=swap');
.grecaptcha-badge {
  display: none;
}
body {
  margin: 0px;
}
#app {
  font-family: "Outfit";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  // *:not(input) {
  // -webkit-user-select: none; /* Safari */
  // -ms-user-select: none; /* IE 10+ and Edge */
  // user-select: none; /* Standard syntax */
  // }
  input {
    font-family: "Outfit";
  }
  input::placeholder {
    font-family: "Outfit";
  }
  textarea {
    font-family: "Outfit";
    color: $text-color;
  }
}
.toast {
  font-family: "Open sans";
  font-size: 14px;
  font-weight: 700;
  opacity: 1 !important;
  flex-direction: row-reverse;
  border-radius: 5px;
  // height: 63px;
  min-height: 63px;

  .toast-icon {
    margin-right: 20px;
    background-image: url("./assets/icons/toastClose.png") !important;
    width: 13px !important;
    min-width: 13px !important;
    height: 13px !important;
  }
}
.toast.toast-success {
  background: #02d294 !important;
}
.toast.toast-error {
  background: #f3545e !important;
}
.toast.toast-default {
  background: linear-gradient(90.45deg, #8b3d4c -1.87%, #6b3349 101.6%);
}
.toast * {
  opacity: 1;
}
.page-help {
  margin: 0 auto;
  max-width: 1320px;
  width: calc(100% - 40px);
}
// pagination
ul.pagination {
  display: flex;
  list-style-type: none;
  align-items: center;
  padding-left: 0px;
  font-family: Outfit;

  li {
    margin-right: 10px;
    height: 20px;
    min-width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    a {
      // outline: none;
      // width: 100%;
      // height: 100%;
      // font-weight: bold;
      // font-size: 13px;
      // line-height: 20px;

      font-weight: 500;
      font-style: Medium;
      font-size: 18px;
      line-height: 26px;
      letter-spacing: 0%;
      color: $gray-blue-1300;
    }
  }
  li:first-of-type,
  li:last-of-type {
    border: 1px solid $gray-blue-700; // $gray-blue-700
    box-shadow: 0px 2px 5px #0000000f;
    border-radius: 10px;
    height: 60px;
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: $gray-100;
    padding: 0px;

    a {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      user-select: none;
    }
  }
  li:first-of-type:active,
  li:last-of-type:active {
    box-shadow: 0px 2px 5px #00000000;
  }
  li.disabled {
    box-shadow: none;
    cursor: default;
    a {
      cursor: default;
    }
  }
  li:last-child {
    margin-right: 0px;
  }
  li.active {
    // box-shadow: 0px -2px 0px $main-color;
    // color: $main-color;
    // border-top: 2px solid $main-color;
    cursor: default;
    a {
      cursor: default;
      color: $blue-600;
    }
  }
}

//tooltip
.tooltip {
  display: block !important;
  z-index: 10000;
  font-family: "Outfit";
}

.tooltip .tooltip-inner {
  background: $gray-100;
  color: $blue-400;
  padding: 18px;
  box-shadow: 0 5px 30px rgba(black, 0.01);
  // background: black;
  // color: white;
  border-radius: 10px;
  padding: 5px 10px 4px;
  border: 1px solid $gray-blue-700;
  max-width: 400px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: $gray-100;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}
@media screen and (max-width: 768px) {
  ul.pagination {
    display: flex;
    list-style-type: none;
    align-items: center;
    padding-left: 0px;
    font-family: Outfit;

    li {
      margin-right: 10px;
      height: 20px;
      min-width: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      a {
        // outline: none;
        // width: 100%;
        // height: 100%;
        // font-weight: bold;
        // font-size: 13px;
        // line-height: 20px;

        font-weight: 500;
        font-style: Medium;
        font-size: 18px;
        line-height: 26px;
        letter-spacing: 0%;
        color: $gray-blue-1300;
      }
    }
    li:first-of-type,
    li:last-of-type {
      height: 40px;
      width: 40px;

      a {
        width: 100%;
        height: 100%;
      }
    }
    li:first-of-type:active,
    li:last-of-type:active {
      box-shadow: 0px 2px 5px #00000000;
    }
    li.disabled {
      box-shadow: none;
      cursor: default;
      a {
        cursor: default;
      }
    }
    li:last-child {
      margin-right: 0px;
    }
    li.active {
      // box-shadow: 0px -2px 0px $main-color;
      // color: $main-color;
      // border-top: 2px solid $main-color;
      cursor: default;
      a {
        cursor: default;
        color: $blue-600;
      }
    }
  }
}
</style>
